module.exports = __webpack_public_path__ + "media/images/bg/patterns/activities/4-ac13a1da6790368432d0e1e34b2b863c.svg";